import React, { useEffect, useState } from 'react';
import cls from './cashback.module.scss';
import { Icon } from 'lb-components';
import { CashBackBronzeIcon } from '../../../../assets/icons/menu';
import { ProgressBar } from 'react-bootstrap';
import { Button } from 'lb-components';
import { Api, useTranslation } from 'lb-store';
import { UseAlert } from 'lb-store/src/hooks';
import { CashbackHeaderIcon } from '../../../../assets/icons';

const levels = [
  { label: 'BRONZE', color: '#ffb668' },
  { label: 'SILVER', color: '#A7A7A7' },
  { label: 'GOLD', color: '#f5a70c' },
  { label: 'PLATIN', color: '#666666' },
  { label: 'LEADER', color: '#BB7F08' },
];

const Cashback = ({ setRoute }) => {
  const {t} = useTranslation()
  const alert = UseAlert();
  const [data, setData] = useState({
    value: '0.00',
    percent: 0,
    level: 1,
    active: '0',
    bar: '5',
  });
  useEffect(() => {
    Api.User.Level().then((res) => {
      if (res.status && res.data?.status === 1) {
        //console.log(res);
        setData({
          value: res.data?.levelData?.value,
          percent: parseInt(res.data?.levelData?.percent),
          level: parseInt(res.data?.levelData?.level),
          active: res.data?.levelData?.active,
          bar: res.data?.levelData?.bar,
        });
      }
    });
  }, []);

  const cashbackHandler = () => {
    const isEligible =
      data.level === 1
        ? parseFloat(data.value) >= parseFloat(data.bar)
        : parseFloat(data.value) >= 10;
    if (!isEligible) {
      alert.open({
        message: (
          <div style={{ fontSize: '1.45rem' }}>
            {t("ქეშბექის განსახორციელებლად აუცილებელია სტატუსის შესაბამისი თანხის დაგროვება!")}
          </div>
        ),
      });
    } else {
      Api.User.Cashback().then((res) => {
        const success = res.status && res.data?.status === 1;
        if (success) {
          setData({
            active: res?.data?.cashbackData['cashback-active'],
            bar: res?.data?.cashbackData['cashback-bar'],
            level: res?.data?.cashbackData['cashback-level'],
            percent: res?.data?.cashbackData['cashback-percent'],
            value: res?.data?.cashbackData['cashback-value'],
          });
        }
        alert.open({
          message: success ? t('ქეშბექი განაღდებულია!') : res.data?.desc,
        });
      });
    }
  };

  return (
    <div className={cls.cashback}>
      <div className={cls.title}>
        <h3>
          {t("ქეშბექის განსახორციელებლად აუცილებელია სტატუსის შესაბამისი თანხის დაგროვება")}
        </h3>
      </div>
      <div className={cls.status}>
        <Icon
          Icon={CashbackHeaderIcon}
          style={{
            width: '5rem',
            height: '5rem',
            backgroundSize: '5rem',
            backgroundPosition: `0px -${(data.level - 1) * 5}rem`,
          }}
        />
        <span
          className={cls.statusText}
          style={{ color: levels[data.level - 1].color }}
        >
          {levels[data.level - 1].label}
        </span>
      </div>

      <div className={cls.progress}>
        <ProgressBar
          label={data.value}
          variant='success'
          now={data.percent}
          animated={true}
          style={{
            borderRadius: '2rem',
            backgroundColor: ' #33353d',
            height: '2rem ',
            fontSize: '2rem',
            fontWeight: 'bold',
          }}
        />
        <div className={cls.labels}>
          <span>{data.active} GEL</span>
          <span>{data.bar} GEL</span>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '2rem',
        }}
      >
        <Button
          variant={'secondary'}
          className={cls.button}
          onClick={cashbackHandler}
        >
          {t("განაღდება")}
        </Button>
      </div>
    </div>
  );
};
export default Cashback;
